var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoMin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.80184 16.966C1.92908 16.6524 1.05199 16.426 0.182759 16.2766C0.445663 17.6878 0.931255 19.0818 1.66204 20.4072C3.79656 24.2784 7.51939 26.7092 11.5659 27.3418C11.4186 23.1011 7.99033 18.8306 2.80184 16.966ZM3.29599 12.6653C10.1452 12.0664 15.417 6.71653 16.0524 0.211622C13.0685 -0.317898 9.8914 0.132837 7.03271 1.71672C2.87883 4.01828 0.384054 8.16133 0 12.5696C1.06863 12.7247 2.17201 12.7635 3.29599 12.6653ZM13.684 16.9278C13.5088 20.7465 14.7108 24.3082 16.8487 27.1328C18.0295 26.8503 19.1927 26.4086 20.3071 25.7912C26.9388 22.1168 29.3432 13.7487 25.6777 7.1008C24.888 5.66864 23.8802 4.43451 22.72 3.41412C17.6087 5.80551 13.961 10.8878 13.684 16.9278Z",
    fill: "url(#paint0_linear_2898_2330)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2898_2330",
    x1: 0,
    y1: 13.6709,
    x2: 27.3925,
    y2: 13.6709,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CD9F28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ECD80B"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoMin);
export default __webpack_public_path__ + "static/media/logoMin.41e25fd650a2dac4321ab5c50cce2533.svg";
export { ForwardRef as ReactComponent };